import { type EntitiesCompetitors } from '../../../states/entities/competitors';
import { type CompetitorState } from '../../../states/entities/competitors';
import { type StateType } from '../../../states/index';
import { type Selector } from '../../../types/selectors';
import { getCompetitorIdFromProps } from '../../_propsGetters_';
import { selectEntitiesState } from '../entitiesPrimary.selector';

const emptyObject = {};

export const selectEntitiesCompetitors: Selector<EntitiesCompetitors> = (state: StateType) =>
  selectEntitiesState(state).competitors ?? emptyObject;

//#region state.entities.competitors
type EntitiesCompetitorsSelectorProps = {
  competitorId?: number;
};

export const selectEntitiesCompetitorsEntity: Selector<CompetitorState | undefined> = (
  state: StateType,
  props: EntitiesCompetitorsSelectorProps = {},
) => {
  const competitorId = getCompetitorIdFromProps(state, props);

  if (competitorId) {
    return selectEntitiesCompetitors(state)[competitorId];
  }
};
//#endregion

//#region state.entities.competitors[competitorId]
export const selectEntitiesCompetitorsEntityCompetitorId: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesCompetitorsSelectorProps = {},
) => selectEntitiesCompetitorsEntity(state, props)?.competitorId;

export const selectEntitiesCompetitorsEntityName: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesCompetitorsSelectorProps = {},
) => selectEntitiesCompetitorsEntity(state, props)?.name;

export const selectEntitiesCompetitorsEntityShortname: Selector<string | null | undefined> = (
  state: StateType,
  props: EntitiesCompetitorsSelectorProps = {},
) => selectEntitiesCompetitorsEntity(state, props)?.shortname;

export const selectEntitiesCompetitorsEntityJerseyBase: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesCompetitorsSelectorProps = {},
) => selectEntitiesCompetitorsEntity(state, props)?.jerseyBase;

export const selectEntitiesCompetitorsEntityFormationType: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesCompetitorsSelectorProps = {},
) => selectEntitiesCompetitorsEntity(state, props)?.formationType;

export const selectEntitiesCompetitorsEntityPlayers: Selector<Array<number> | undefined> = (
  state: StateType,
  props: EntitiesCompetitorsSelectorProps = {},
) => selectEntitiesCompetitorsEntity(state, props)?.players;

export const selectEntitiesCompetitorsEntityLineupAvailable: Selector<boolean | undefined> = (
  state: StateType,
  props: EntitiesCompetitorsSelectorProps = {},
) => selectEntitiesCompetitorsEntity(state, props)?.lineupAvailable;

export const selectEntitiesCompetitorsEntityStartingOrder: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesCompetitorsSelectorProps = {},
) => selectEntitiesCompetitorsEntity(state, props)?.startingOrder;

export const selectEntitiesCompetitorsEntityPosition: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesCompetitorsSelectorProps = {},
) => selectEntitiesCompetitorsEntity(state, props)?.position;

export const selectEntitiesCompetitorsEntityPitStops: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesCompetitorsSelectorProps = {},
) => selectEntitiesCompetitorsEntity(state, props)?.pitStops;

export const selectEntitiesCompetitorsEntityGapToLeader: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesCompetitorsSelectorProps = {},
) => selectEntitiesCompetitorsEntity(state, props)?.gapToLeader;

export const selectEntitiesCompetitorsEntityRetired: Selector<boolean> = (
  state: StateType,
  props: EntitiesCompetitorsSelectorProps = {},
) => selectEntitiesCompetitorsEntity(state, props)?.retired ?? false;
//#endregion
